export default __webpack_public_path__ + "static/media/dropdown-arrow-blue.dafdc888.svg";